import {Component, Input, OnInit} from '@angular/core';

@Component({
    selector: 'app-content-tab-list',
    templateUrl: './categorize-tab-list.component.html',
    styleUrls: ['./categorize-tab-list.component.css'],
    standalone: false
})
export class CategorizeTabListComponent implements OnInit {

  @Input() activeTab = 0;
  @Input() category = '';
  @Input() type = '';

  tabOptions = {
    management:
      [
        {label: 'Memberships', link: '/memberships'},
        {label: 'Score models', link: '/management/score-models'},
      ],
    entities:
      [
        {label: 'Entities', link: '/entities'},
        {label: 'Super categories', link: '/super-categories'},
        {label: 'Categories', link: '/categories'},
        {label: 'Rating categories', link: '/rating-categories'},
      ],
    cms:
      [
        {label: 'Banners', link: '/banners'},
        {label: 'Icons', link: '/icons'},
        {label: 'NFTs', link: '/nfts-collection'},
        {label: 'Hindutva laboratory', link: '/cms/hindutva-laboratory'},
      ],
    communication: [
      {label: 'News', link: '/news'},
      {label: 'Suggestions', link: '/suggestions'},
    ],
    user: [
      {label: 'Users', link: '/users'},
      {label: 'Organizations', link: '/organizations'},
      {label: 'Quotes', link: '/quotes'},
      {label: 'Claim requests', link: '/claim'},
      {label: 'Podcasts', link: '/podcasts'},
      {label: 'User funding', link: '/users/user-funding'},
    ],
    marketplace: [
      {label: 'Books', link: '/marketplace/books'},
      {label: 'Projects', link: '/marketplace/projects'},
      {label: 'Satire', link: '/marketplace/satire'},
      {label: 'Requests', link: '/marketplace/requests'},
    ],
    twitter: [
      {label: 'Golden Handles', link: '/twitter/golden-list'},
      {label: 'Posts Dashboard', link: '/twitter/posts-dashboard'},
      {label: 'Webhook Requests', link: '/twitter/webhook-requests'},
      {label: 'Posting Session', link: '/twitter/session'},
    ],
    ecommerce: [
      {label: 'Categories', link: '/ecommerce/categories'},
      {label: 'Products', link: '/ecommerce/products'},
      {label: 'Orders', link: '/ecommerce/orders'},
    ],
  };

  ngOnInit(): void {
  }
}
